import { render, staticRenderFns } from "./TabServiceSummary.vue?vue&type=template&id=7244dae8"
import script from "./TabServiceSummary.vue?vue&type=script&lang=js"
export * from "./TabServiceSummary.vue?vue&type=script&lang=js"
import style0 from "./TabServiceSummary.vue?vue&type=style&index=0&id=7244dae8&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7244dae8')) {
      api.createRecord('7244dae8', component.options)
    } else {
      api.reload('7244dae8', component.options)
    }
    module.hot.accept("./TabServiceSummary.vue?vue&type=template&id=7244dae8", function () {
      api.rerender('7244dae8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/billingHistory/components/tabs/TabServiceSummary.vue"
export default component.exports